// Created by hejikun on 2017/11/2 0002.
let kunhuaPhysicalExamination = [
  // ===================================
  // 1. 机构主页与基础信息
  // ===================================
  {
    path: '/kunhua_physicalExamination_index',
    name: '昆华-体检机构主页',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_index')
  },
  {
    path: '/kunhua_physicalExamination_inde_detail',
    name: '昆华-体检机构详情',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_inde_detail')
  },
  {
    path: '/kunhua_physicalExamination_star_list',
    name: '昆华-评价列表',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_star_list')
  },

  // ===================================
  // 2. 套餐列表与详情
  // ===================================
  {
    path: '/kunhua_physicalExamination_oneList',
    name: '昆华-套餐列表',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_oneList')
  },
  {
    path: '/kunhua_physicalExamination_oneList_kunhua',
    name: '昆华-套餐列表',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_oneList_kunhua')
  },
  {
    path: '/kunhua_physicalExamination_detail',
    name: '昆华-套餐详情',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_detail')
  },
  {
    path: '/kunhua_physicalExamination_recommend_more',
    name: '昆华-推荐套餐列表',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_recommend_more')
  },

  // ===================================
  // 3. 下单与加项流程
  // ===================================
  {
    path: '/kunhua_physicalExamination_order_confirm',
    name: '昆华-订单确认',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_order_confirm')
  },
  {
    path: '/kunhua_physicalExamination_addition',
    name: '昆华-套餐自选加项',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_addition')
  },
  {
    path: '/kunhua_pay_confirm',
    name: '昆华-套餐自选加项',
    component: () => import('@/pages/kunhuaPhysicalExamination/pay_confirm')
  },

  // ===================================
  // 4. 支付流程
  // ===================================
  {
    path: '/kunhua_physicalExamination_orderPay',
    name: '昆华-订单支付',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_orderPay')
  },

  // ===================================
  // 5. 订单管理与售后
  // ===================================
  {
    path: '/kunhua_physicalExamination_orderList',
    name: '昆华-订单列表',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_orderList')
  },
  {
    path: '/kunhua_physicalExamination_new_detail',
    name: '昆华-体检订单详情',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_new_detail')
  },
  {
    path: '/kunhua_physicalExamination_orderDetail',
    name: '昆华-订单详情',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_orderDetail')
  },
  {
    path: '/kunhua_physicalExamination_change_time',
    name: '昆华-变更确认',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_change_time')
  },
  {
    path: '/kunhua_physicalExamination_evaluate',
    name: '昆华-体检评价',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_evaluate')
  },

  // ===================================
  // 6. 售后加项业务
  // ===================================
  {
    path: '/kunhua_physicalExamination_add_items',
    name: '昆华-体检加项',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_add_items')
  },
  {
    path: '/kunhua_physicalExamination_add_detail',
    name: '昆华-体检加项详情',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_add_detail')
  },
  {
    path: '/kunhua_physicalExamination_add_order_list',
    name: '昆华-体检加项订单列表',
    component: () => import('@/pages/kunhuaPhysicalExamination/physicalExamination_add_order_list')
  }
]
export default kunhuaPhysicalExamination
